import * as React from 'react';

import {SearchBar} from 'shells/search-bar/search-bar';

import {NutshellFieldPicker} from '../../../core/nutshell-fields';
import {getIcon, getTitle, getSubtitle} from '../../../core/nutshell-fields/helpers';
import type {FormFieldSchema, FormSchemaProperty} from '../../../core/nutshell-fields/types';

import type {MergeTagOption} from './add-merge-field';
import {Fallback} from './fallback';
import {getFilteredFields, getSelectedField} from './helpers';
import {SelectedFieldCard} from './selected-field-card';

import styles from './add-merge-field.module.css';

type Props = {
    formSchema: FormFieldSchema;
    selectedMergeTag: MergeTagOption | null | undefined;
    setSelectedMergeTag: (arg1?: MergeTagOption | null | undefined) => void;
    searchValue: string;
    setSearchValue: (arg1: string) => void;
    fallbackValue: string;
    setFallbackValue: (arg1: string) => void;
};

export function CustomFields(props: Props) {
    const {selectedMergeTag} = props;

    const getMergeTagValuesFromField = (item: FormSchemaProperty) => ({
        label: item.name,
        value: item.mergeTagName,
        fallback: null,
    });

    const selectedField = selectedMergeTag && getSelectedField(props.formSchema, selectedMergeTag);

    return (
        <>
            {selectedField ? (
                <>
                    <div className={styles['selected-card']}>
                        <SelectedFieldCard
                            title={getTitle(selectedField)}
                            subtitle={getSubtitle(
                                selectedField.entityType,
                                selectedField.isCustomField,
                                selectedField.displayType
                            )}
                            icon={getIcon(selectedField.entityType)}
                            onRemove={() => props.setSelectedMergeTag(null)}
                        />
                    </div>
                    <Fallback
                        fallbackValue={props.fallbackValue}
                        setFallbackValue={props.setFallbackValue}
                        label={selectedField.label.toLocaleLowerCase()}
                    />
                </>
            ) : (
                <>
                    <div className={styles.search}>
                        <SearchBar
                            value={props.searchValue}
                            onChange={props.setSearchValue}
                            isClearable={true}
                            hasBorder={true}
                            placeholder='Search person and company custom fields…'
                        />
                    </div>

                    <div className={styles['custom-fields-container']}>
                        <NutshellFieldPicker
                            onSelectField={(field: FormSchemaProperty) =>
                                // @ts-expect-error
                                props.setSelectedMergeTag(getMergeTagValuesFromField(field))
                            }
                            customFilterFunction={(schemaFields: FormSchemaProperty[]) =>
                                getFilteredFields(schemaFields)
                            }
                            searchValue={props.searchValue}
                        />
                    </div>
                </>
            )}
        </>
    );
}
